<template>
    <div class="article-videos">
        <p>
            All improvised to random song. In the Strictly Swing division you enter with a partner. But in a Jack &
            Jill, your partner is chosen at random moments before.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleVideos',
};
</script>
